import { render, staticRenderFns } from "./CommentTextCreator.vue?vue&type=template&id=1c4d8f2f&scoped=true"
import script from "./CommentTextCreator.vue?vue&type=script&lang=ts"
export * from "./CommentTextCreator.vue?vue&type=script&lang=ts"
import style0 from "./CommentTextCreator.vue?vue&type=style&index=0&id=1c4d8f2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d8f2f",
  null
  
)

export default component.exports